<script setup lang="ts">
const props = defineProps<{
  color: string;
}>();
</script>

<template>
 <svg width="20" height="20" viewBox="0 0 20 20" focusable="false" role="none" aria-hidden="true" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0058 18C8.90472 18 7.86806 17.7917 6.89583 17.375C5.92361 16.9583 5.07292 16.3854 4.34375 15.6563C3.61458 14.9271 3.04167 14.0777 2.625 13.1081C2.20833 12.1385 2 11.1025 2 10C2 8.88264 2.20785 7.84174 2.62354 6.87729C3.03924 5.91299 3.60917 5.065 4.33333 4.33333L10 10V2C11.1111 2 12.1493 2.20833 13.1146 2.625C14.0799 3.04167 14.9271 3.61458 15.6563 4.34375C16.3854 5.07292 16.9583 5.92167 17.375 6.89C17.7917 7.85847 18 8.89319 18 9.99417C18 11.0953 17.7917 12.1319 17.375 13.1042C16.9583 14.0764 16.3854 14.9271 15.6563 15.6563C14.9271 16.3854 14.0783 16.9583 13.11 17.375C12.1415 17.7917 11.1068 18 10.0058 18Z"
      :fill="color" />
  </svg>
</template>
